/**
 * /dashboard/expenses/batches — Reimbursement batches (Phase 3d).
 *
 * HR-admin only — the body itself state-gates the non-admin case with a
 * "no access" card (the strip already hides this item for non-admins,
 * this is defence-in-depth for a direct nav).
 *
 * Migration note: port of
 * frontend/src/app/(dashboard)/dashboard/expenses/batches/page.tsx.
 */

import { createFileRoute } from "@tanstack/react-router";
import { ExpensesModuleShell } from "@/components/shared/expenses-module-shell";
import { ExpenseFeatureGate } from "@/components/expenses/expense-feature-gate";
import { BatchesTab } from "@/components/expenses/batches-tab";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/expenses/batches",
)({
  component: ExpenseBatchesRoute,
});

function ExpenseBatchesRoute() {
  return (
    <ExpensesModuleShell
      title="Reimbursements"
      description="Build and run payout batches for approved expenses."
    >
      <ExpenseFeatureGate>
        <BatchesTab />
      </ExpenseFeatureGate>
    </ExpensesModuleShell>
  );
}
